import Http from "@/plugins/http.js"

export default {

    //获取个人资料信息
    SaveMemoRandum(param) {
        return Http.POST(`api/PlatformAssist/SaveMemoRandum`, param);
    },
    //获取个人资料信息的逻辑
    getMemoRandum() {
        return Http.GET('api/PlatformAssist/getMemoRandum');
    },

}